module.exports = __webpack_public_path__ + "media/images/logo-twitter-e291a68ec3c5f6078272493a516e0a0c.svg";